function validerQuestion4() {
  const sexe = document.querySelector('input[name="sexe"]:checked');
  const age = document.querySelector('input[name="age"]:checked');
  const agenda = document.querySelector('input[name="agenda"]:checked');
  const intolerances = document.querySelectorAll('input[name="regimeAlimentaire"]:checked');

  if (sexe && age && agenda && intolerances.length > 0) {
    const profil = document.getElementById('profil');
    if (profil) profil.style.display = 'none';
    const question4 = document.querySelector('#valider1')?.parentElement;
    if (question4) question4.style.display = 'none';
    const moments = document.getElementById('moments');
    if (moments) {
      moments.classList.add('slide-fade-in');
      setTimeout(() => { moments.style.display = 'block'; }, 50);
      moments.style.display = 'block';
    }
  } else {
    alert('Veuillez rÃ©pondre Ã  toutes les questions avant de valider.');
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function validerQuestion5() {
  const momentsSelected = document.querySelectorAll('input[name="moments"]:checked');
  if (momentsSelected.length === 0) {
    alert('Veuillez choisir un moment avant de valider.');
    return;
  }

  const moments = document.getElementById('moments');
  if (moments) moments.style.display = 'none';
  const besoins = document.getElementById('besoins');
  if (besoins) {
    besoins.classList.add('slide-fade-in');
    setTimeout(() => { besoins.style.display = 'block'; }, 50);
    besoins.style.display = 'block';
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function onBesoinsSelection() {
  const envies1 = document.getElementById('envies1');
  if (envies1) {
    envies1.classList.add('slide-fade-in');
    envies1.style.display = 'block';
  }
}

function validerQuestion6() {
  const sexe = document.querySelector('input[name="sexe"]:checked');
  const age = document.querySelector('input[name="age"]:checked');
  const agenda = document.querySelector('input[name="agenda"]:checked');
  const intolerances = document.querySelectorAll('input[name="regimeAlimentaire"]:checked');
  const enviesSelectionnees = document.querySelectorAll('input[name="envies1"]:checked');
  const besoinsSelectionnes = document.querySelectorAll('input[name="besoins"]:checked');

  if (!sexe || !age || !agenda || intolerances.length === 0 || enviesSelectionnees.length === 0 || besoinsSelectionnes.length === 0) {
    alert('Veuillez complÃ©ter toutes les rÃ©ponses avant de valider.');
    return;
  }

  if (typeof checkCriteria === 'function') checkCriteria(true);

  const besoins = document.getElementById('besoins');
  const envies1 = document.getElementById('envies1');
  const products = document.getElementById('products');
  if (besoins) besoins.style.display = 'none';
  if (envies1) envies1.style.display = 'none';
  if (products) {
    products.classList.add('slide-fade-in');
    setTimeout(() => { products.style.display = 'block'; }, 50);
    products.style.display = 'block';
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function bindListeners() {
  document.querySelectorAll('input[name="besoins"]').forEach(input => {
    input.addEventListener('change', onBesoinsSelection);
  });
}

document.addEventListener('DOMContentLoaded', bindListeners);